// extracted by mini-css-extract-plugin
export var avatar = "UserDropdown-module--avatar--2KT0Q";
export var container = "UserDropdown-module--container--RGZFl";
export var content = "UserDropdown-module--content--PUzSl";
export var menuItem = "UserDropdown-module--menuItem--837Yb";
export var toggleButton = "UserDropdown-module--toggleButton--Q5wyg";